// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import * as bootstrap from "bootstrap"
import toastr from 'toastr'
import moment from 'moment'
import Choices from 'choices.js'
import DataTable from 'datatables.net-bs5'
import DataTableLanguage from 'datatables.net-plugins/i18n/ru.mjs'
import Inputmask from 'inputmask'

moment.locale('ru')

window.moment = moment
window.toastr = toastr
window.bootstrap = bootstrap
window.Choices = Choices
window.DataTable = DataTable
window.DataTableLanguage = DataTableLanguage
window.Inputmask = Inputmask

window.toastOptions = {
  "closeButton": true,
  "positionClass": "toast-top-right",
  "onclick": null,
  "showDuration": "300",
  "hideDuration": "1000",
  "timeOut": "5000",
  "extendedTimeOut": "1000",
  "showEasing": "swing",
  "hideEasing": "linear",
  "showMethod": "fadeIn",
  "progressBar": true,
  "hideMethod": "fadeOut"
};

window.choicesConfigDefault = {
  removeItemButton: true,
  placeholder: true,
  placeholderValue: 'Выберите вариант',
  searchPlaceholderValue: "Введите текст для поиска...",
  loadingText: 'Загрузка...',
  noResultsText: 'Результаты не найдены',
  noChoicesText: 'Нет вариантов для выбора',
  itemSelectText: 'Нажмите для выбора',
  uniqueItemText: 'Только уникальные',
  customAddItemText: 'Можно добавлять только значения, соответствующие определенным условиям',
  searchResultLimit: 15
}

window.choicesConfig = {
  ...choicesConfigDefault,
  searchChoices: false,
  searchFloor: 2
}

function rerender() {
  init()
}

window.rerender = rerender

function copyLink(link) {
  navigator.clipboard.writeText(link)
  toastr['info']('Ссылка скопирована в буфер', '', toastOptions)
}
window.copyLink = copyLink

function toggleChecked(element) {
  element.closest('table').querySelectorAll("tbody input").forEach(e => {e.checked = element.checked})
}

window.toggleChecked = toggleChecked
addEventListener('turbo:load', rerender)

function init() {
  document.querySelectorAll(".clickable-row td:not(.nolink)").forEach(e => {
    e.addEventListener("click", function() {
      window.location = this.closest('tr').dataset.href;
    })
  });

  document.querySelectorAll(".datatable").forEach(e => {
    e.datatable = new DataTable(e, {
      language: DataTableLanguage,
      paging: false
    });
  });

  document.querySelectorAll('.select-choices').forEach(e => {
    // Destroy existing Choices instance before creating a new one
    if (e.choices) {
      e.choices.destroy()
    }
    e.choices = new Choices(e, choicesConfigDefault)
  })

  // Инициализация маски телефона для полей с классом phone-field
  document.querySelectorAll('.phone-field').forEach(e => {
    Inputmask({
      mask: '+7 (999) 999-99-99',
      placeholder: '_',
      showMaskOnHover: false,
      showMaskOnFocus: true
    }).mask(e)
  })

  // Инициализация маски email для полей с классом email-field
  document.querySelectorAll('.email-field').forEach(e => {
    Inputmask({
      alias: 'email',
      showMaskOnHover: false
    }).mask(e)
  })


  /**
   * Easy selector helper function
   */
  const select = (el, all = false) => {
    el = el.trim()
    if (all) {
      return [...document.querySelectorAll(el)]
    } else {
      return document.querySelector(el)
    }
  }

  /**
   * Easy event listener function
   */
  const on = (type, el, listener, all = false) => {
    if (all) {
      select(el, all).forEach(e => e.addEventListener(type, listener))
    } else {
      select(el, all).addEventListener(type, listener)
    }
  }

  /**
   * Easy on scroll event listener
   */
  const onscroll = (el, listener) => {
    el.addEventListener('scroll', listener)
  }

  /**
   * Sidebar toggle
   */
  if (select('.toggle-sidebar-btn')) {
    on('click', '.toggle-sidebar-btn', function(e) {
      select('body').classList.toggle('toggle-sidebar')
    })
  }

  /**
   * Navbar links active state on scroll
   */
  let navbarlinks = select('#navbar .scrollto', true)
  const navbarlinksActive = () => {
    let position = window.scrollY + 200
    navbarlinks.forEach(navbarlink => {
      if (!navbarlink.hash) return
      let section = select(navbarlink.hash)
      if (!section) return
      if (position >= section.offsetTop && position <= (section.offsetTop + section.offsetHeight)) {
        navbarlink.classList.add('active')
      } else {
        navbarlink.classList.remove('active')
      }
    })
  }
  window.addEventListener('load', navbarlinksActive)
  onscroll(document, navbarlinksActive)

  /**
   * Toggle .header-scrolled class to #header when page is scrolled
   */
  let selectHeader = select('#header')
  if (selectHeader) {
    const headerScrolled = () => {
      if (window.scrollY > 100) {
        selectHeader.classList.add('header-scrolled')
      } else {
        selectHeader.classList.remove('header-scrolled')
      }
    }
    window.addEventListener('load', headerScrolled)
    onscroll(document, headerScrolled)
  }

  /**
   * Back to top button
   */
  let backtotop = select('.back-to-top')
  if (backtotop) {
    const toggleBacktotop = () => {
      if (window.scrollY > 100) {
        backtotop.classList.add('active')
      } else {
        backtotop.classList.remove('active')
      }
    }
    window.addEventListener('load', toggleBacktotop)
    onscroll(document, toggleBacktotop)
  }

  /**
   * Initiate tooltips
   */
  var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
  var tooltipList = tooltipTriggerList.map(function(tooltipTriggerEl) {
    return new bootstrap.Tooltip(tooltipTriggerEl)
  })
};
